import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { type ModelAnnoucementCampaign, type ModelDetail, type ModelList } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './models.actions';

interface ModelsState {
    modelList: Loadable<ModelList>;
    modelDetail: Loadable<ModelDetail>;
    modelAnnoucementCampaign: Loadable<ModelAnnoucementCampaign>;
}

const initialState: ModelsState = {
    modelList: null,
    modelDetail: null,
    modelAnnoucementCampaign: null,
};

export const state = createFeature({
    name: 'models',
    reducer: createReducer(
        initialState,
        on(
            actions.loadModelList,
            (state): ModelsState => ({
                ...state,
                modelList: null,
            }),
        ),
        on(
            actions.loadModelListSuccess,
            (state, { modelList }): ModelsState => ({
                ...state,
                modelList,
            }),
        ),
        on(
            actions.loadModelListFailure,
            (state): ModelsState => ({
                ...state,
                modelList: false,
            }),
        ),
        on(
            actions.loadModelDetail,
            (state): ModelsState => ({
                ...state,
                modelDetail: null,
            }),
        ),
        on(
            actions.loadModelDetailSuccess,
            (state, { model }): ModelsState => ({
                ...state,
                modelDetail: model,
            }),
        ),
        on(
            actions.loadModelDetailFailure,
            (state): ModelsState => ({
                ...state,
                modelDetail: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingModelList = createSelector(
            baseSelectors.selectModelList,
            (modelList) => modelList === null,
        );
        const selectLoadedModelList = createSelector(
            baseSelectors.selectModelList,
            (modelList) => modelList as Loaded<ModelList>,
        );
        const selectIsLoadingModelDetail = createSelector(
            baseSelectors.selectModelDetail,
            (modelDetail) => modelDetail === null,
        );
        const selectLoadedModelDetail = createSelector(
            baseSelectors.selectModelDetail,
            (modelDetail) => modelDetail as Loaded<ModelDetail>,
        );

        return {
            selectIsLoadingModelList,
            selectLoadedModelList,
            selectIsLoadingModelDetail,
            selectLoadedModelDetail,
        };
    },
});
